import React from "react";
import image from "../media/image.PNG";
import "../styles/views.css";

const Views = () => {
  return (
    <div className='sliders download'>
      <section class='section3'>
        <div className='item1'>
          <img src={image} alt='' />
        </div>
        <div>
          <h1>
            Download your shows <br />
            to watch offline.
          </h1>
          <h2>
            Save your favorites easily and always have <br />
            something to watch.
          </h2>
        </div>
      </section>
    </div>
  );
};

export default Views;
